// @flow
import React from 'react';
import bem from '@justpark/helpers/src/bem/bem';

import '../../../static/scss/components/ui/fancyBanner.scss';
import useGetFeature from '../../hooks/useGetFeature';

type UIProps = {
  background: string,
  color: string,
  copy: string,
  cta: string,
  ctaUrl: string,
  image: string
};

export const FancyBannerUI = ({
  background,
  color,
  copy,
  cta,
  ctaUrl,
  image
}: UIProps) => {
  const baseClass = 'c-fancy-banner';

  return (
    <div
      className={bem(baseClass)}
      style={{
        background,
        color
      }}
    >
      <div className={bem(baseClass, 'container')}>
        {image && (
          <div className={bem(baseClass, 'image')}>
            <img src={image} alt="Feature" />
          </div>
        )}
        <div className={bem(baseClass, 'content')}>
          <div className={bem(baseClass, 'copy')}>{copy}</div>
          <a href={ctaUrl} className={bem(baseClass, 'cta')}>
            {cta}
          </a>
        </div>
      </div>
    </div>
  );
};

const FancyBanner = () => {
  const feature = useGetFeature('fancy_banner');

  if (!feature || feature.enabled === false) {
    return null;
  }

  const {
    background,
    color,
    copy,
    cta,
    ctaUrl,
    image
  } = feature.variantAttachment;

  return (
    <FancyBannerUI
      background={background}
      color={color}
      copy={copy}
      cta={cta}
      ctaUrl={ctaUrl}
      image={image}
    />
  );
};

export default FancyBanner;
